const KEY = "hk_ref";
const TTL = 30 * 24 * 3600 * 1000; // 30 days

export function captureRefFromUrl() {
  try {
    const p = new URLSearchParams(window.location.search);
    const ref = p.get("ref");
    if (ref) localStorage.setItem(KEY, JSON.stringify({ code: ref.trim().toUpperCase(), ts: Date.now() }));
  } catch {
    /* ignore */
  }
}

export function getRef() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw);
    if (Date.now() - ts > TTL) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code || null;
  } catch {
    return null;
  }
}

export function clearRef() {
  localStorage.removeItem(KEY);
}
